module.exports = __webpack_public_path__ + "static/media/pharmacore-paragon-color.1ba9343d.png";